export default __webpack_public_path__ + "static/media/042-biologist.07ad3bba.svg";